import { useQuery } from "@tanstack/react-query"

import { listHostedAgentSourcesApi } from "@/api/client/hosted-agents-sources"

/** Scoped by agent and session so source metadata never crosses workspaces. */
export function useAgentSources(agentRef: string, sessionId?: string | null, enabled = true) {
  return useQuery({
    // A disabled task query on the greeting must not read the permanent query's
    // cache; that would count and render every permanent source twice.
    queryKey: [
      "hosted-agent-sources",
      agentRef,
      sessionId ?? (enabled ? "permanent" : "no-session"),
    ],
    queryFn: () => listHostedAgentSourcesApi(agentRef, sessionId),
    enabled,
    staleTime: 0,
    // A revoked/deleted source must disappear while the work surface stays open.
    refetchInterval: 30_000,
    retry: false,
  })
}
